module.exports = __webpack_public_path__ + "static/media/about_mock.7736773d.png";